import { Link, useParams } from "react-router-dom";
import styled from "styled-components";

import useLocation from "../hooks/useLocation";

const TabsLink = styled(Link)<{ active: boolean }>`
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  flex: 1;
  flex-basis: 0;
  color: #010024;
  text-decoration: none;
  background-color: #b8b7cf;
  font-size: 14px;
  font-weight: bold;
  ${({ active }) =>
    active &&
    `
    background-color: white;
    border-top: 2px solid #52ff6e;
    padding-bottom: 2px;
  `}
`;

const TabsList = styled.div`
  display: flex;
`;

const ManageRoutesTabNavigation = () => {
  const { competitionUUID } = useParams();
  const location = useLocation();

  const areasActive = location.pathname.endsWith("areas");
  const categoriesActive = location.pathname.endsWith("categories");

  return (
    <TabsList>
      <TabsLink
        active={areasActive}
        to={`/${competitionUUID}/manage-routes/areas`}
        replace
      >
        Areas
      </TabsLink>
      <TabsLink
        active={categoriesActive}
        to={`/${competitionUUID}/manage-routes/categories`}
        replace
      >
        Categories
      </TabsLink>
    </TabsList>
  );
};

export default ManageRoutesTabNavigation;
